export default __webpack_public_path__ + "static/media/library_light.db3da841.svg";